export default __webpack_public_path__ + "static/media/SATURN.f7945732.png";